export default __webpack_public_path__ + "static/media/link-arrow.05147bea.svg";